/* 
    this is a field that's either a typography (when isEditing = false)
    or it's a text field (when isEditing = true)
    */
import React from "react";
import {
  Box,
  Typography,
  TextField,
} from "@mui/material";

const EditableField = ({
  label,
  value,
  name,
  onChange,
  isEditing,
  options = null,
  error = null,
  type = "text",
  variant = "body1",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1.5,
        "& .MuiBox-root": {
          mr: 0,
          width: "100%", 
        },
      }}
    >
      <Box
        sx={{
          width: "160px",
          minWidth: "160px",
          textAlign: "center",
          mr: 4,
        }}
      >
        {" "}
        <Typography
          variant={variant}
          sx={{
            fontWeight: "bold",
            textDecoration: "underline",
            whiteSpace: "nowrap",
          }}
        >
          {label}:
        </Typography>
      </Box>

      <Box sx={{ flexGrow: 1, textAlign: "center" }}>
        {isEditing ? (
          <TextField
            select={!!options}
            size="small"
            name={name}
            value={value || ""}
            onChange={onChange}
            variant="outlined"
            error={!!error} // Turns red if error is a truthy string
            type={type}
            helperText={error}
            FormHelperTextProps={{
              sx: {
                position: "absolute", // Prevents the error from pushing the grid around
                bottom: "-18px", // Positions it right under the box
                marginLeft: 0,
                color: "#ff1744",
              },
            }}
            sx={{
              width: "100%",
              mb: error ? 2 : 0, // Add extra margin if there's an error
              "& .MuiInputBase-input": { padding: "8.5px 14px" },
            }}
            SelectProps={{ native: true }}
          >
            {options &&
              options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
          </TextField>
        ) : (
          <Typography variant={variant}>
            {options
              ? options.find((o) => o.value === value)?.label || value
              : value || "—"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default EditableField;
